import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { faChartDiagram } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import styled from 'styled-components';

const NodeContainer = styled.div`
  padding: 10px;
  border-radius: 8px;
  background: #E0F7FA;
  border: 1px solid #00ACC1;
  width: 200px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
`;

const NodeHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const NodeIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #00ACC1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin-right: 8px;
`;

const NodeLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #00ACC1;
  flex: 1;
`;

const NodeDescription = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
`;

const DocumentNode = ({ data }) => {
  const {
    name = 'Document conversion',
    description = 'Generate PDF document from HTML template',
  } = data;
  
  return (
    <NodeContainer>
      <Handle type="target" position={Position.Top} />
      
      <NodeHeader>
        <NodeIcon><FontAwesomeIcon icon={faChartDiagram} /></NodeIcon>
        <NodeLabel>{name}</NodeLabel>
      </NodeHeader>
      
      <NodeDescription>{description}</NodeDescription>
      
      <Handle type="source" position={Position.Bottom} />
    </NodeContainer>
  );
};

export default memo(DocumentNode);
